<template>
	<div class="class">
		<studentNav :current="current" @info-event="myInfoEvent" @public-event="publicEvent"></studentNav>
		<div class="class_cont bg_blue">
			<div class="class_div radius8 bs bg_white">
				<div class="class_title flex">
					<p class="f30px cl_dark">加入班级</p>
				</div>
				<div class="add_class">
					<div class="add_class_tip cl_yel f16px">
						<p>如果没有找到您的班级，可以尝试以下操作：</p>
						<p>1. 检查学校和年级信息是否正确；</p>
						<p>2. 确认老师是否已经创建了班级；</p>
						<p>3. 若以上信息无误，仍无法找到您的班级请联系客服 ：{{public.web_phone}}</p>
					</div>
					<div class="add_class_search mat25" v-if="myInfo.school_id == '' || myInfo.school_id == null">
						<div class="add_search_div">
							<input type="text" placeholder="请输入关键词" v-model="school_name" class="add_search_input f16px" @input="search"
							  v-on:compositionstart="flagg=false" v-on:compositionend="flagg=true" autocomplete="off" />
							<ul class="add_search_hide bs bg_white cl_dark f16px" v-if="school_list_show == true">
								<li class="add_search_list cur flex" v-for="(item,index) in school_list" :key="index" @click.stop="searchList(index)">
									<span>{{item.name}}</span>
									<i>{{item.province_name}} {{item.city_name}} {{item.town_name}}</i>
								</li>
								<li v-if="school_list.length == 0">找不到内容</li>
							</ul>
						</div>
					</div>
					<div class="mat30" v-if="JSON.stringify(school_cur) != '{}'">
						<div class="f16px cl_dark" v-if="myInfo.school_id == '' || myInfo.school_id == null">{{school_cur.province_name}}/{{school_cur.city_name}}/{{school_cur.town_name}} {{school_cur.name}}</div>
						<div class="f16px cl_dark" v-if="myInfo.school_name != ''">{{myInfo.school_name}}</div>
						<div class="test_screen cl_gray mat40" v-if="myInfo.grade_id==0">
							<div class="test_screen_l f16px"><span class="inline">选择年级</span><i class="inline">：</i></div>
							<div class="test_screen_r tc">
								<span class="test_screen_list bg_gray" v-for="(item,index) in grade" :key="index" :class="{'on':item.gradeId==grade_cur.gradeId}" @click="gradeCheck(index)">{{item.gradeName}}</span>
							</div>
						</div>
						<div class="add_empty bg_blue radius8 mat20 f16px cl_gray tc" v-if="list.class_normal_data.length == 0 && list.class_tutor_data.length == 0">
							<p>对不起，你所在的年级还没有创建班级，你可以联系你的班主任在趣学云创建班级<br>班主任可以致电 <span class="cl_violet">{{public.web_phone}}</span> 联系客服</p>
						</div>
						<div class="add_cont bg_blue radius8 mat20" v-else>
							<div class="add_cont_div" v-if="list.class_normal_data.length > 0">
								<div class="add_cont_div_title f20px cl_violet mat10">加入行政班</div>
								<div class="add_cont_mid f16px cl_dark mat10 tc">
									<div class="add_cont_list bg_white radius8 cur" v-for="(item,index) in list.class_normal_data" :key="index"
									 :class="{'on': item.is_select == 1}" @click="normalAdd(index)">{{item.name}}</div>
								</div>
							</div>
							<div class="add_cont_div" v-if="list.class_tutor_data.length > 0 && myInfo.school_name != ''">
								<div class="add_cont_div_title f20px cl_violet mat10">加入教学班</div>
								<div class="add_cont_mid f16px cl_dark mat10 tc">
									<div class="add_cont_list bg_white radius8 cur" v-for="(item,index) in list.class_tutor_data" :key="index"
									 :class="{'on': item.is_select == 1}" @click="tutorAdd(index)">{{item.name}}</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		
		<!-- 输入班主任姓名 -->
		<el-dialog title="身份验证" :visible.sync="masterShow" width="30%" center>
		  <div class="f16px">
				<p class="cl_dark"><span class="cl_red">*</span>请输入要加入班级的班主任姓名</p>
				<input type="text" v-model="masterName" class="f16px mat10 edit_name_input" />
			</div>
		  <div slot="footer" class="dialog-footer">
		    <el-button @click="masterShow = false">取 消</el-button>
		    <el-button type="primary" @click="masterConfirm">确 定</el-button>
		  </div>
		</el-dialog>
	</div>
</template>

<script>
	import studentNav from '../../components/student_nav.vue'
	
	export default {
		name: 'add_class',
		components: {
			studentNav,
		},
		props: {
			
		},
		data () {
			return {
				myInfo: {},
				public: {},
				current: {
					navCur: 2,
					listCur: 0,
					open: 0,
				},
				school_name: "", //搜索
				flagg: false,
				school_list_show: false, //学校
				school_list: [],
				school_cur: {},
				grade: [], //年级班级
				grade_cur: {},
				list: {
					class_normal_data: [],
					class_tutor_data: [],
				},
				list_cur: {},
				list_type: "",
				masterShow: false, //班主任验证
				masterName: "",
			}
		},
		created() {
			
		},
		mounted() {
			var that = this;
			document.getElementsByTagName('body')[0].onclick = function () {
				that.school_list_show = false;
			};
		},
		methods: {
			myInfoEvent (data) {
				this.myInfo = data;
				if (this.myInfo.school_name != "") {
					this.school_cur.id = this.myInfo.school_id;
					this.school_cur.school_name = this.myInfo.school_name;
					this.grade_cur.gradeId = this.myInfo.grade_id;
					this.getClass();
				}
				if(data.grade_id==0){
					this.$get("/api/schoolclass/get_school_grade_data",{
						school_id:data.school_id,
						token: localStorage.getItem("token"),
					}).then(res=>{
						this.grade=res.data
					})
				}
			},
			publicEvent (data) {
				this.public = data;
			},
			//搜索
			search () {
				var that = this;
				that.school_list_show = true;
				setTimeout(function(){
					if(that.flagg){
						that.getSchool();
					}
				},0)
			},
			//学校
			getSchool () {
				this.$get("/api/schoolclass/get_school_data",{
					token: localStorage.getItem("token"),
					name: this.school_name,
				})
				.then(res => {
					this.school_list = [];
					this.school_list = res.data;
				});
			},
			searchList (e) {
				this.school_cur = this.school_list[e];
				this.school_name = this.school_cur.name;
				this.school_list_show = false;
				this.getGrade();
			},
			//年级班级
			getGrade () {
				this.$get("/api/schoolclass/get_school_grade_data",{
					token: localStorage.getItem("token"),
					school_id: this.school_cur.id,
				})
				.then(res => {
					this.grade = res.data;
					this.grade_cur = this.grade[0];
					this.getClass();
				});
			},
			gradeCheck (e) {
				this.grade_cur = this.grade[e];
				this.getClass();
			},
			getClass () {
				this.$get("/api/schoolclass/get_grade_class_data",{
					token: localStorage.getItem("token"),
					school_id: this.school_cur.id,
					grade_id: this.grade_cur.gradeId,
				})
				.then(res => {
					this.list = res.data;
				});
			},
			//加入行政班
			normalAdd (e) {
				if (this.list.class_normal_data[e].is_select == 1) {
					return false;
				} else {
					if (this.myInfo.class_name != "") {
						this.$messageBox.confirm('确定要从 ' + this.myInfo.class_name + ' 转移到 ' + this.list.class_normal_data[e].name + ' 吗?', '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning'
						}).then(() => {
							this.masterName = "",
							this.masterShow = true;
							this.list_type = "normal";
							this.list_cur = this.list.class_normal_data[e];
						}).catch(() => {
							
						});
					} else {
						this.masterName = "",
						this.masterShow = true;
						this.list_type = "normal";
						this.list_cur = this.list.class_normal_data[e];
					}
				}
			},
			//加入教学班
			tutorAdd (e) {
				if (this.list.class_tutor_data[e].is_select == 1) {
					return false;
				} else {
					this.masterName = "",
					this.masterShow = true;
					this.list_type = "tutor";
					this.list_cur = this.list.class_tutor_data[e];
				}
			},
			//确认
			masterConfirm () {
				this.$get("/api/schoolclass/post_join_class",{
					token: localStorage.getItem("token"),
					class_id: this.list_cur.id,
					real_name: this.masterName,
				})
				.then(res => {
					this.$message({
						type: 'success',
						message: res.msg,
						duration: 1500,
					});
					this.masterShow = false;
					if (this.myInfo.school_name == "") {
						location.reload();
					} else {
						this.getClass();
					}
				});
			},
		},
	}
</script>

<style>
</style>
